import AddTeamMemberModal from './AddTeamMemberModal.component';

export default AddTeamMemberModal;
